/** @jsx h */
import { h } from 'preact'

const SvgComponent = () => (
  <svg width={28} height={32}>
    <g fill='none' fillRule='evenodd'>
      <path
        stroke='#2F3A4A'
        strokeDasharray='1 2'
        strokeWidth={1.5}
        d='M17.077 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6z'
      />
      <path
        fill='#2F3A4A'
        fillRule='nonzero'
        d='M12.75 16h-1.5c0-.39.048-.78.143-1.17l1.457.356a3.42 3.42 0 0 0-.1.814zm.849-2.412l-1.238-.847c.196-.287.418-.573.665-.858l1.133.983c-.21.243-.397.484-.56.722zm1.432-1.838v-1.5h1v1.5h-1zm3 0v-1.5H19c-.052.002-.052.002-.087.007l.236 1.48c-.067.01-.067.01-.149.013h-.969zm3.139-1.256l-.922-1.184c.243-.189.5-.396.765-.613l.953 1.159c-.274.225-.543.44-.796.638zm2.34-1.97l-1.012-1.108c.19-.173.35-.324.47-.445.098-.098.222-.193.372-.292l.825 1.253a1.122 1.122 0 0 0-.137.1c-.138.139-.314.305-.519.492zm2.268-1.293l-.368-1.454c.528-.134.989-.167 1.384-.056l-.404 1.444c-.091-.025-.316-.009-.612.066zm-.006.514l1.233.853c-.171.248-.374.526-.609.835l-1.194-.907c.222-.293.412-.553.57-.78zm-1.797 2.33l1.163.947c-.195.24-.403.494-.637.777l-1.157-.955c.232-.28.438-.531.631-.769zm-1.904 2.307l1.156.955c-.25.303-.451.549-.629.768l-1.165-.945c.18-.223.385-.472.638-.778zm-1.972 5.87l1.497.094-.064 1-1.497-.097.064-.997zm-.191 2.995l1.497.092c-.022.359-.041.687-.058.994l-1.498-.083c.017-.31.037-.64.059-1.003zm-.147 3.023l1.5.04c-.008.256-.011.486-.011.69h-1.5c0-.219.004-.462.01-.73z'
      />
      <circle cx={9.077} cy={11} r={3} stroke='#2F3A4A' />
      <path
        stroke='#2F3A4A'
        d='M5 28c-.423-4-.5-8-.5-10-1.5-1-5-7-4-8C1.73 8.77 4 16 8 16c1 0 5 .5 6 .5 5 0 7.5-2.5 8-1.5s-4 4-7 4c0 2 0 6-.5 9'
      />
    </g>
  </svg>
)

export default SvgComponent
